import html2pdf from "html2pdf.js";
import { styles } from "./constants";

const downloadPdf = async (callback, margin) => {
  let date = new Date();
  var element = document.getElementById("pdf");

  let time = `${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}_${
    date.toLocaleTimeString().split(":")[0]
  }_${date.toLocaleTimeString().split(":")[1]}`;

  var opt = {
    margin: margin || [0.2, 0],
    filename: `resume_${time}.pdf`,
    image: { type: "jpeg", quality: 1 },
    html2canvas: { scale: 4,  useCORS: true, allowTaint: false },
    jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
  };

  // New Promise-based usage:
  await html2pdf()
    .from(element)
    .set(opt)
    .save()

  callback?.();
};

const printPdf = (activeDesign) => {
  console.log("activeDesign", activeDesign);
  let mywindow = window.open(
    "",
    "PRINT",
    "height=650,width=794,top=100,left=150"
  );

  mywindow.document.write(`<html><head>`);
  mywindow.document.write(`<style>
  *{
    font-family: "Roboto", sans-serif;
    color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  body{
      margin: 0
  }
 
  #printBtn{cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 40px;
    border-radius: 4px;
    font-family: inherit;
    font-weight: 500;
    text-decoration: none;
    padding: 8px 12px;
    border: 0px rgb(82, 104, 219);
    transition: all 0.3s ease 0s;
    color: rgb(255, 255, 255);
    background-color: rgb(82, 104, 219);
    background-image: linear-gradient( 31deg, rgba(215, 178, 233, 0.4) 0%, rgba(83, 105, 220, 0.4) 100% );
    min-width: 120px;
    font-size: 14px;}
    
    @media print{
        #printBtn{
            display:none;
        }
     }
</style>`);
  mywindow.document.write(`<style>${styles[activeDesign]}</style>`);
  mywindow.document.write(
    `<style>@page { size: auto;  margin: 5mm 0mm; } @page :first {margin-top: 0}</style>`
  );
  mywindow.document.write("</head><body >");
  mywindow.document.write(document.getElementById("pdf").innerHTML);
  mywindow.document.write(
    `<div style="text-align:center"><button id="printBtn" onclick="mtpr()">Print</button></div>`
  );
  mywindow.document.write(`<script>
  window.scrollTo({left: 0, top: document.body.scrollHeight, behavior:'smooth'});

  function mtpr() {
    window.print();
    window.close()
  }
  </script>`);
  mywindow.document.write("</body></html>");

  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/

  // mywindow.print();
  // mywindow.close();

  // return true;
};

export { downloadPdf, printPdf };
